export const useTournamentMatrix = () => {
    /**
     * Transforms a tournament stage into matrix-ready format
     * Similar to LeagueCycleDivisionDetailResponse structure
     *
     * @param {Object} stage - TournamentStageResponse
     * @param {Object} tournament - TournamentDetailResponse
     * @returns {Object} Matrix-ready stage data with team fixtures
     */
    const transformStageForMatrix = (stage, tournament) => {
        if (!stage || !tournament) return null;

        // Backend now provides teams with fixtures already populated!
        // TournamentStageTeamResponse extends TeamDetailResponse and includes:
        // - id, name, players, initials, etc. (from TeamDetailResponse)
        // - position, points, bonusPoints, totalPoints (calculated standings)
        // - fixtures[] (with teamId and opponentTeamId for O(1) lookup)
        // This matches the LeagueCycleDivisionDetailResponse pattern exactly!

        return {
            id: stage.id,
            name: stage.name,
            clubId: tournament.clubId,
            scoringSystem: tournament.scoringSystem,
            closed: false, // Tournaments don't have a closed state like league divisions
            teams: stage.teams || []
        };
    };

    /**
     * Get fixture between two teams from the matrix data
     * Used by matrix component to look up fixture for each cell
     */
    const getFixture = (homeTeam, awayTeam, scoringSystem, stageId) => {
        if (!homeTeam || !awayTeam) return null;

        // Find existing fixture
        const found = homeTeam.fixtures?.find(f => f.opponentTeamId === awayTeam.id);
        if (found) return found;

        // Return placeholder for creating new fixture
        return {
            scoringSystem: scoringSystem,
            tournamentStageId: stageId,
            homeTeamId: homeTeam.id,
            awayTeamId: awayTeam.id,
        };
    };

    return {
        transformStageForMatrix,
        getFixture
    };
};
